module.exports = __webpack_public_path__ + "img/catseye02.df10883c.jpg";